import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import NavSidebar from './NavSidebar';

/**
 * MobileOverlay — 手机端交互控制
 *
 * - 左上角 ☰ → 导航抽屉（左侧滑出 + 遮罩）
 * - 右下角 🤖 → Agent 浮层（底部滑出 72vh + 遮罩，taro-ai 的面板挂载进来）
 * - 点遮罩/浮层外部 → 自动收起；两个浮层互斥
 *
 * Agent 浮层显隐与 app.sarahAi.panelOpen 联动：
 * - 打开 sheet 时强制 panelOpen=true（萨拉面板本体才有内容）
 * - 关闭 sheet 时 panelOpen=false（与萨拉自己的关闭逻辑一致）
 */
export default class MobileOverlay extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.navOpen = false;
    this.agentOpen = false;

    // 手机端导航跳转后自动关抽屉
    document.addEventListener('taroshell:nav-close', () => {
      this.navOpen = false;
      m.redraw();
    });
  }

  openNav() {
    this.navOpen = true;
    this.agentOpen = false; // 互斥
    this._syncAgentPanel();
    m.redraw();
  }

  openAgent() {
    this.agentOpen = true;
    this.navOpen = false;
    if (app.sarahAi) app.sarahAi.panelOpen = true;
    this._mountAgentIntoSheet();
    m.redraw();
  }

  closeAll() {
    this.navOpen = false;
    this.agentOpen = false;
    if (app.sarahAi) app.sarahAi.panelOpen = false;
    m.redraw();
  }

  _syncAgentPanel() {
    if (app.sarahAi) app.sarahAi.panelOpen = this.agentOpen;
  }

  /** 把 taro-ai 的萨拉面板 wrapper 挂到 sheet 内（面板本体由 taro-ai 渲染） */
  _mountAgentIntoSheet() {
    setTimeout(() => {
      const sheetBody = document.querySelector('.TaroShell-agentSheetBody');
      const wrapper = document.querySelector('.SarahPanel-wrapper');
      if (sheetBody && wrapper && wrapper.parentElement !== sheetBody) {
        sheetBody.appendChild(wrapper);
      }
      m.redraw();
    }, 0);
  }

  view() {
    const anyOpen = this.navOpen || this.agentOpen;

    return (
      <div className="TaroShell-mobileUI">
        <button
          className="TaroShell-mobileNavBtn"
          onclick={() => this.openNav()}
          aria-label="打开导航菜单"
        >
          <i className="fas fa-bars" />
        </button>

        <button
          className={'TaroShell-mobileAgentBtn' + (this.agentOpen ? ' is-open' : '')}
          onclick={() => (this.agentOpen ? this.closeAll() : this.openAgent())}
          aria-label={this.agentOpen ? '收起 Agent' : '唤起 Agent'}
        >
          <i className={this.agentOpen ? 'fas fa-chevron-down' : 'fas fa-robot'} />
        </button>

        {anyOpen && <div className="TaroShell-overlay" onclick={() => this.closeAll()} />}

        {this.navOpen && (
          <div className="TaroShell-navDrawer">
            <NavSidebar />
          </div>
        )}

        {this.agentOpen && (
          <div className="TaroShell-agentSheet">
            <div className="TaroShell-agentSheetGrip" onclick={() => this.closeAll()}>
              <span className="TaroShell-agentSheetGripBar" />
            </div>
            <div className="TaroShell-agentSheetBody" />
          </div>
        )}
      </div>
    );
  }
}
